import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

export const EMHOFAZ_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/emhofaz/logo.png",
        alt: "Elevate Mental Health Logo",
        style: { width: "200px", height: "100%", isMobile: { width: "150px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 201,
  state: "AZ",
  departmentIds: [518, 519, 521],
};
